import * as React from "react";
import { Apps28Regular, Apps28Filled } from "@fluentui/react-icons";
import { TeamAppConfig } from "Apps/TeamAppModel";

const OnRApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "OnR" */ "./OnRApp");
    return { default: namedExport.OnRApp };
});

export const OnR: TeamAppConfig = {
    title: "Onboarding and Readiness",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "Overview of the onboarding of services to automation components",
    team: "ONR",
    publicId: "ONBOARDINGANDREADINESSDASHBOARD\\m365-OnUR",
    owner: "onr-Support@microsoft.com",
    role: "*",
    tags: ["ONR"],
    app: OnRApp,
    path: "/OnR"
};
